import { Injector } from '@angular/core';
import { ServiceBus } from './service-bus';

export function initFactory(injector: Injector) {
  return () => {
    const serviceBus = injector.get(ServiceBus);
    return serviceBus.initialize().toPromise();
  };
}
